export default {"src":"/_next/static/media/en.e774c232.svg","height":650,"width":1235,"blurWidth":0,"blurHeight":0};